import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {Country} from '../../interface/location/country';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }
  get(id: number): Observable<any>{

    return this.http.get(`${this.baseUrl}/get/country/${id}`);
  }
  getCollection(): Observable<Country[]>{
    return this.http.get<Country[]>(`${this.baseUrl}/get/countries`);
  }

  post(data: Country): Observable<any>{
    return this.http.post<Country>(`${this.baseUrl}/create/country`, data);
  }

  put(id: number, data: Country): Observable<any>{
    return this.http.put<Country>(`${this.baseUrl}/edit/country/${id}`, data);
  }

  delete(id: number): Observable<Country>{
    return this.http.delete<Country>(`${this.baseUrl}/delete/country/` + id);
  }

  deleteMultiple(ids: number[]): Observable<Country[]>{
    const options = {body: ids};
    return this.http.delete<Country[]>(`${this.baseUrl}/delete/countries`, options);
  }

}
